import { ESCAPE } from '@angular/cdk/keycodes';
import {
    ChangeDetectorRef,
    EventEmitter,
    Inject,
    Injector,
    Optional,
    Output,
} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
} from '@angular/material/dialog';
import { ModalResultType } from '@models';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';

import {
    filter,
    takeUntil,
} from 'rxjs/operators';

export class ModalData<T> {
    public data: T;
    public isNewEntry: boolean;
    public isDuplicate?: boolean;
    public additionalData: any;
    public isBlocking = false;
    public size: 'sm' | 'lg' | null = null;

    constructor(model?: T) {
        this.isNewEntry = model === undefined;
        this.data = <T>(model || {});
    }
}

export interface IModalResult<T> {
    type: ModalResultType;
    data?: T;
    additionalData?: any;
}
export abstract class UiModalComponent<T, R = IModalResult<T>> {
    @Output()
    public customEvent = new EventEmitter<R>();

    constructor(
        protected _injector: Injector,
        protected _cd: ChangeDetectorRef,
        protected _snack: UiSnackBarService,
        protected _dialogRef: MatDialogRef<UiModalComponent<T>, R>,
        @Optional() @Inject(MAT_DIALOG_DATA) public context: ModalData<T>,
    ) {
        _dialogRef.keydownEvents()
            .pipe(
                filter(event => event.keyCode === ESCAPE),
                takeUntil(_dialogRef.beforeClosed()),
            )
            .subscribe(event => {
                event.stopPropagation();
                this.closeModal();
            });
    }

    public closeModal() {
        this._dialogRef.close();
    }
}
